module.exports = __webpack_public_path__ + "img/carousel-clientes-3.bbd3ddfd.png";